import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider, useTheme } from "@/hooks/use-theme";
import { LanguageProvider } from "@/hooks/use-language";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Problem } from "@/components/sections/Problem";
import { Manifesto } from "@/components/sections/Manifesto";
import { Architecture } from "@/components/sections/Architecture";
import { Deliverables } from "@/components/sections/Deliverables";
import { Benchmark } from "@/components/sections/Benchmark";
import { Security } from "@/components/sections/Security";
import { Leadership } from "@/components/sections/Leadership";
import { ContactForm } from "@/components/sections/ContactForm";
import { Privacy, Terms } from "@/pages/Legal";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Problem />
    <Manifesto />
    <Architecture />
    <Deliverables />
    <Benchmark />
    <Security />
    <Leadership />
    <ContactForm />
  </main>
);

const ThemedToaster = () => {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" />;
};

function App() {
  useEffect(() => {
    if (sessionStorage.getItem("s360-visited")) return;
    sessionStorage.setItem("s360-visited", "1");
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/visitors`, {
        path: window.location.pathname,
        referrer: document.referrer || "",
        user_agent: navigator.userAgent,
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
      <div className="App" data-testid="app-root">
        <div className="grain-overlay" />
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <ThemedToaster />
      </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
